import { fullVideo, video } from './videoModal.css';
import { PlainModal, PlainModalProps } from './modal';
import { clsx } from 'clsx';

type VideoModalProps = PlainModalProps & {
  src: string;
  hideCloseButton?: boolean;
  videoClassName?: string;
};

export const VideoModal = (p: VideoModalProps) => (
  <>
    <PlainModal {...p} modalClassName={clsx(fullVideo, p?.modalClassName)}>
      <video
        src={p.src}
        preload="auto"
        controls
        className={clsx(video, p?.videoClassName)}
      />
    </PlainModal>
  </>
);
